var _circle, _rect, _g, _line, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeofenceInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 246,
    height: 61,
    viewBox: "0 0 246 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.4688,
    cy: 30.75,
    r: 30,
    fill: "#F6EFE9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_813_741",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 41,
    height: 41
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.4688,
    y: 10.75,
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_813_741)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_813_741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.4688 14.75C28.5102 14.75 26.6319 15.528 25.247 16.9129C23.8622 18.2978 23.0841 20.1761 23.0841 22.1346C23.0841 26.2134 29.5075 36.3414 29.5075 41.8269H31.43C31.43 36.3598 37.8534 25.8811 37.8534 22.1346C37.8534 20.1761 37.0753 18.2978 35.6905 16.9129C34.3056 15.528 32.4273 14.75 30.4688 14.75ZM30.4688 18.4423C31.448 18.4423 32.3872 18.8313 33.0796 19.5238C33.772 20.2162 34.1611 21.1554 34.1611 22.1346C34.1611 23.1139 33.772 24.053 33.0796 24.7455C32.3872 25.4379 31.448 25.8269 30.4688 25.8269C29.4895 25.8269 28.5503 25.4379 27.8579 24.7455C27.1655 24.053 26.7764 23.1139 26.7764 22.1346C26.7764 21.1554 27.1655 20.2162 27.8579 19.5238C28.5503 18.8313 29.4895 18.4423 30.4688 18.4423ZM22.8921 36.0189C22.8658 36.0311 22.84 36.0443 22.8146 36.0583C20.5438 36.4571 18.6189 37.0035 17.1617 37.7506C16.4318 38.1235 15.8029 38.5654 15.3155 39.0958C14.8269 39.6275 14.4688 40.318 14.4688 41.0958C14.4688 42.2626 15.2417 43.1746 16.1611 43.8269C17.0804 44.4792 18.2411 44.9777 19.6614 45.4035C22.4983 46.2552 26.2903 46.75 30.4688 46.75C34.6472 46.75 38.4392 46.2552 41.2761 45.4035C42.6952 44.9777 43.8571 44.4805 44.7764 43.8269C45.6958 43.1746 46.4688 42.2626 46.4688 41.0958C46.4688 40.3155 46.1118 39.5894 45.622 39.0577C45.1321 38.526 44.5094 38.1235 43.7758 37.7494C42.3112 37.0023 40.3678 36.4558 38.0835 36.0571C37.9229 36.026 37.7577 36.0272 37.5976 36.0606C37.4374 36.0941 37.2856 36.1592 37.1509 36.252C37.0162 36.3448 36.9013 36.4636 36.8131 36.6014C36.7248 36.7391 36.6649 36.8931 36.6368 37.0542C36.6088 37.2154 36.6131 37.3806 36.6496 37.54C36.6861 37.6995 36.7541 37.8501 36.8495 37.983C36.9449 38.1159 37.0658 38.2285 37.2052 38.3141C37.3446 38.3997 37.4997 38.4567 37.6614 38.4817C39.782 38.8509 41.5444 39.374 42.6608 39.9426C43.2195 40.2257 43.6121 40.5297 43.8152 40.75C44.0183 40.9703 44.0072 41.0577 44.0072 41.0958C44.0072 41.1537 43.9284 41.4195 43.3537 41.8269C42.7789 42.2343 41.7992 42.6811 40.5451 43.0577C38.038 43.8097 34.4466 44.2885 30.4688 44.2885C26.4909 44.2885 22.8995 43.8097 20.3912 43.0577C19.1383 42.6811 18.1586 42.2343 17.5851 41.8269C17.0091 41.4195 16.9303 41.1537 16.9303 41.0958C16.9303 41.0589 16.9217 40.9691 17.1223 40.75C17.3241 40.5309 17.7217 40.2257 18.2768 39.9426C19.3844 39.3752 21.1297 38.8522 23.238 38.4805C23.402 38.4606 23.5604 38.4082 23.7039 38.3263C23.8474 38.2445 23.9732 38.1349 24.0738 38.0039C24.1745 37.8729 24.248 37.7231 24.2902 37.5634C24.3323 37.4036 24.3421 37.2371 24.3192 37.0735C24.2962 36.9099 24.2408 36.7525 24.1563 36.6106C24.0718 36.4686 23.9598 36.3449 23.827 36.2467C23.6941 36.1485 23.543 36.0778 23.3825 36.0387C23.222 35.9996 23.0553 35.9929 22.8921 36.0189Z",
    fill: "#8F4300",
    fillOpacity: 0.5
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 61.9688,
    y1: 30.25,
    x2: 243.969,
    y2: 30.25,
    stroke: "#F6EFE9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_813_741"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(14.4688 14.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeofenceInactive);
export default __webpack_public_path__ + "static/media/geofence_inactive.ed9950baf815bd93325a023e88765908.svg";
export { ForwardRef as ReactComponent };